import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors, ConfigScopesEnum } from 'builder/modules/init'
import { selectors as userSelectors } from 'builder/modules/user'
import { FeaturesConfig } from './FeaturesConfig'

export const useFeaturesConfig = (): FeaturesConfig => {
  const user = useTypedSelector(userSelectors.userData)
  const features = useTypedSelector(state => {
    return selectors.config(state, ConfigScopesEnum.app)?.features
  })

  return new FeaturesConfig(features, user)
}
